module.exports = __webpack_public_path__ + "static/media/logo.e414042a.jpg";